<template>
    <div class="player" @click="play()" :class="{ 'disabled': disabled }">
        <div class="action">
            <span class="icon-play" :class="{ 'playing': playing }"></span>
            <span v-if="duration">
                {{ duration }}
                <span class="seconds">"</span>
            </span>
        </div>
        <div class="status">
            <i class="el-icon-warning-outline error" v-if="error"></i>
            <i class="el-icon-loading loading" v-if="loading"></i>
        </div>
        <audio ref="audio" :src="src" @loadedmetadata="loadedMetaData" @pause="onPause" @play="onPlay"
            @timeupdate="onTimeUpdate" @error="onError"></audio>
    </div>
</template>

<script>

export default {
    name: "VoicePlayer",
    props: {
        src: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            disabled: true,
            loading: true,
            error: false,
            playing: false,
            totalDuration: 0,
            currentTime: 0
        }
    },
    computed: {
        duration() {
            return Math.ceil(this.totalDuration - this.currentTime)
        }
    },
    mounted() {
        if (!this.src) return;
    },
    methods: {
        play() {
            if (this.disabled) return;
            if (this.playing) {
                this.stop();
            } else {
                this.$refs.audio.play()
            }
        },
        stop() {
            this.$refs.audio.pause();
            this.$refs.audio.currentTime = 0;
        },
        loadedMetaData(e) {
            this.totalDuration = e.target.duration;
            this.loading = false;
            this.disabled = false;
        },
        onPause() {
            this.playing = false;
            this.currentTime = 0;
        },
        onPlay() {
            this.playing = true;
            this.$emit('play', this)
        },
        onTimeUpdate(e) {
            this.currentTime = e.target.currentTime;
        },
        onError() {
            this.playing = false;
            this.loading = false;
            this.error = true;
            this.disabled = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.player {
    height: 40px;
    width: 200px;
    padding: 0 10px;
    background-color: #95ec69;
    border-radius: 5px;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all .3s;

    audio {
        display: none;
        opacity: 0;
        width: 0;
        height: 0;
    }

    &:active,
    &:hover {
        background-color: #84d35e;
    }

    &.disabled {
        cursor: not-allowed;
        background-color: #f1f3f4;

        .icon-play {
            opacity: 0.3;
        }
    }

    .action {
        display: flex;
        align-items: center;
    }

    .status {
        font-size: 18px;


        .error {
            color: #F56C6C;
        }

        .loading {
            color: #555;
        }
    }

    .icon-play {
        width: 24px;
        height: 24px;
        display: block;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(../assets/img/icon-voice-play-three.svg);

        &.playing {
            animation: playing-voice 1.5s linear infinite;
        }
    }
}

@keyframes playing-voice {
    0% {
        background-image: url(../assets/img/icon-voice-play-one.svg);
    }

    50% {
        background-image: url(../assets/img/icon-voice-play-two.svg);
    }

    100% {
        background-image: url(../assets/img/icon-voice-play-three.svg);
    }
}
</style>